import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  all: {
    data: [],
    page: 1,
    size: 10,
    totalData: 0,
    sort: {},
  },
  query: {},
  client_chosen_error: [],
};

export const errorClientSlice = createSlice({
  name: "errorClient",
  initialState,
  reducers: {
    setQueryValue: (state, action) => {
      if (action.payload.key) {
        state.query[action.payload.key] = action.payload.value;
      } else {
        state.query = action.payload;
      }
    },
    addClientChosenError: (state, action) => {
      const ErrorIndex = state.client_chosen_error.indexOf(action.payload);

      if (ErrorIndex >= 0) {
        const tempChosenError = [...state.client_chosen_error];
        tempChosenError.splice(ErrorIndex, 1);
        state.client_chosen_error = tempChosenError;
      } else {
        state.client_chosen_error = [
          ...state.client_chosen_error,
          action.payload,
        ];
      }
    },

    addAllChosenError: (state, action) => {
      const ErrorIndexForAll = state.client_chosen_error.indexOf(
        action.payload
      );
      if (ErrorIndexForAll >= 0) {
        null;
      } else {
        state.client_chosen_error = [
          ...state.client_chosen_error,
          action.payload,
        ];
      }
    },

    clearChosenError: (state, action) => {
      state.client_chosen_error = initialState.client_chosen_error;
    },
  },
});

export const {
  setQueryValue,
  addClientChosenError,
  addAllChosenError,
  clearChosenError,
} = errorClientSlice.actions;

export default errorClientSlice.reducer;
